import { Component, inject } from '@angular/core';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { BreadcrumbsService } from './breadcrumbs.service';
import { BreadcrumbModule } from '@rogers/cdk/breadcrumb';
import { LinkComponent } from '@rogers/cdk/link';
import { IconComponent } from '@rogers/cdk/icon';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fss-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [BreadcrumbModule, LinkComponent, IconComponent, AsyncPipe, TranslatePipe],
})
export class BreadcrumbsComponent {
  private readonly breadcrumbsService = inject(BreadcrumbsService);
  private readonly routingService = inject(RoutingService);

  get breadcrumbs$() {
    return this.breadcrumbsService.breadcrumbs$;
  }

  handleClick(url) {
    this.routingService.navigate(url);
  }
}
